const defaultState = () => {
    return {
        cmsVersion: localStorage.getItem('cmsVersion')
            ? JSON.parse(localStorage.getItem('cmsVersion'))
            : '',
        shouldUpdate: false
    };
};

const state = () => defaultState();

const getters = {
    getCmsVersion: state => state.cmsVersion,

    getShouldUpdate: state => state.shouldUpdate
};

const mutations = {
    setCmsVersion: (state, version) => {
        state.cmsVersion = version;
        localStorage.setItem('cmsVersion', JSON.stringify(version));
    },

    setShouldUpdate: (state, payload) => {
        state.shouldUpdate = payload;
    }
};

const actions = {};

export default {
    state,
    getters,
    mutations,
    actions,
    namespaced: true
};
